import React from 'react';
import { Helmet } from 'react-helmet-async';
import selfDirectedResources from './self-directed-resources.json';
import GoogleAnalytics from '../../analyticsComponents/GoogleAnalytics.js';

function SelfDirectedLearningPage() {
  return (
    <>
      <Helmet>
        <title>Self-Directed Learning Resources - Share2Teach</title>
        <meta
          name="description"
          content="Explore self-directed learning resources and free downloadable books from NWU's Research Unit and AOSIS book series, supporting NWU and NWU Enterprises learners."
        />
        <meta
          name="keywords"
          content="Self-directed Learning, NWU, NWU Enterprises, AOSIS, free educational books, Share2Teach resources"
        />
        <meta property="og:title" content="Self-Directed Learning Resources - Share2Teach" />
        <meta
          property="og:description"
          content="Explore self-directed learning resources and free downloadable books from NWU's Research Unit and AOSIS book series, supporting NWU and NWU Enterprises learners."
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <GoogleAnalytics page="selfDirectedLearningPage" eventType="selfDirectedLearningPage" />

      {/* Header */}
      <div className="max-w-6xl mx-auto px-5 mt-6">
        <div className="flex items-center gap-3">
          <span className="inline-block px-2.5 py-0.5 rounded-full bg-blue-100 text-blue-700 text-xs font-semibold">Explore</span>
          <h1 className="text-2xl font-bold text-gray-900">Self-directed Learning</h1>
        </div>
        <p className="mt-1 text-sm text-gray-500">Curated links and books to help you learn independently and effectively.</p>
      </div>

      <div className="max-w-6xl mx-auto px-5 py-10">
        {/* NWU Research Unit */}
        <div className="bg-white rounded-xl shadow p-6 border border-gray-100 mb-8">
          <h2 className="text-xl md:text-2xl font-semibold mb-3">NWU Research Unit Self-Directed Learning</h2>
          <div className="text-center">
            <a
              href="https://education.nwu.ac.za/research-unit-self-directed-learning/home"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="images/SDL_image.png"
                alt="SDL"
                className="mx-auto w-full max-w-xs rounded-lg shadow-lg border border-white"
              />
            </a>
          </div>
        </div>

        {/* AOSIS Series */}
        <div className="bg-white rounded-xl shadow p-6 border border-gray-100">
          <h2 className="text-xl md:text-2xl font-semibold mb-2">AOSIS NWU Self-Directed Learning book series</h2>
          <p className="mb-6 text-gray-600">Download the books for free from the AOSIS Website (Links on pictures below)</p>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            {selfDirectedResources.resources.map((resource, index) => (
              <div key={index} className="flex flex-col items-center text-center">
                <a href={resource.link} target="_blank" rel="noopener noreferrer" className="block group">
                  <img
                    src={resource.image}
                    alt={resource.title}
                    className="w-28 sm:w-32 md:w-36 h-40 object-cover rounded-md border border-gray-200 shadow-md group-hover:shadow-lg transition"
                  />
                </a>
                <p className="mt-2 text-gray-800 text-sm">{resource.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default SelfDirectedLearningPage;
